.section {
  padding-block: var(--section-y);
  border-top: 1px solid var(--border);
}

.head {
  max-width: 52ch;
  margin-bottom: clamp(2.25rem, 5vw, 3.5rem);
}

.title {
  font-family: var(--font-display);
  font-size: var(--step-3);
  letter-spacing: -0.015em;
  margin-top: 0.6rem;
}

.lead {
  margin-top: 1rem;
  font-size: var(--step-1);
  color: var(--text-dim);
}
